import React from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import ContentPosterContainer from './ContentPosterContainer';

const ContestContainer = () => {
  return (
    <div css={container}>
      <main>
        <ContentPosterContainer />
      </main>
    </div>
  );
};
const container = css`
  width: 100%;
  position: relative;
  max-width: ${theme.maxWidth};
`;
export default ContestContainer;
